// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"f499ba90","501":"7ddd9d7a","513":"f7e6d224","706":"773da0a0","827":"702244d1"}[chunkId] + ".chunk.js";
};